<template>
  <div>
    <div
      v-if="RibbonSettings.visible == 1"
      class="residentportal-alert"
      v-bind:style="
        'background-color:' +
        RibbonSettings.bg_color +
        '; color:' +
        RibbonSettings.text_color
      "
    >
      <div class="container">
        <div class="alert alert-dismissible show mb-0 px-0">
          <div v-html="RibbonSettings.text_color"></div>
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
    </div>
    <!--hidden skip to main content button-->
    <div class="skipnav" v-if="!user && $route.path !== '/login'">
      <a href="#main-content">Skip to main content</a>
    </div>
    <!--LOGGED IN NAV-->
    <nav
      v-if="user"
      class="navbar navbar-expand-lg navbar-collapse navbar-offcanvas logged-in"
    >

      <div class="container">
        <a
          v-if="isMobile === false"
          class="navbar-brand"
          href="#"
          @click.prevent="$router.push('/booking/home').catch((err) => {})"
        >
          <img 
            :src="pubPath + MainUISettings.logo_path" 
            :alt="MainUISettings.logo_path_attribute.alt" 
            :title="MainUISettings.logo_path_attribute.title"
            v-if="MainUISettings.logo_path"
            v-error-img-load 
          />
        </a>
        <div class="collapse navbar-collapse">
          <router-link to="/booking/queued-bookings" class="btn btn--orange btn-back text-white ml-2"
            :style="'background-color:' + MainUISettings.main_site_button_color"
            v-if="isShowQueueBookingPage">Queued Bookings</router-link>
          <button
            type="submit"
            class="btn btn--orange btn-back"
            @click="mainSiteLink()"
            :style="'background-color:' + MainUISettings.main_site_button_color"
            :alt="MainUISettings.logo_path_attribute.alt" 
            :title="MainUISettings.logo_path_attribute.title" 
            :disabled="loading"
            v-else
          >
            {{ MainUISettings.main_site_button_text }}
          </button>
        </div>
        <!-- google translate here -->
        <div class="logged-in-desktop"></div>
        <!-- MOBILE VIEW -->
        <div class="offcanvas-overlay"></div>
        <div class="navbar-collapse offcanvas-collapse">
          <div class="menu-close">
            <i @click="navToggle" class="icon icon-close"></i>
          </div>
          <ul class="navbar-nav mr-auto">
            <li class="nav-item" v-show="isReducedView == false">
              <router-link
                to="/booking/my-profile"
                class="nav-link text-dark"
                @click.native="navToggle"
                >{{ TEXTS.render(`HEADER_PROFILE`) }}</router-link
              >
            </li>
            <li class="nav-item" v-show="isReducedView == false">
              <router-link
                to="/booking/faq"
                class="nav-link text-dark"
                @click.native="navToggle"
                >{{ TEXTS.render(`HEADER_FAQ`) }}</router-link
              >
            </li>
            <li class="nav-item">
              <a
                href="#"
                class="nav-link text-link-blue"
                @click.prevent="logout"
                >{{ TEXTS.render(`HEADER_LOGOUT`) }}</a
              >
            </li>
            <li class="nav-item p-2">
              <!-- This is a space -->
            </li>
            <li class="nav-item" v-if="showBookNow && isReducedView == false">
              <div class="d-flex p-3">
                <!-- 
                  Stry: Adjustment_025 Update book now color button to green
                  Date: 2021-03-04
                  Auth: Franco Mapua
                  Desc: Update book now color button to green
                -->
                <button
                  v-if="is1Coast"
                  style="background-color: #57cd3f; color: white"
                  type="submit"
                  class="btn btn--blue btn-book"
                  :disabled="loading"
                  @click="bookNowMobile"
                >
                  {{ siteWording || TEXTS.render(`HEADER_BTN_BOOK_NOW`) }}
                </button>
                <button
                  v-else
                  type="submit"
                  class="btn btn--blue btn-book"
                  :disabled="loading"
                  @click="bookNowMobile"
                >
                  {{ siteWording || TEXTS.render(`HEADER_BTN_BOOK_NOW`) }}
                </button>
              </div>
            </li>
            <li class="nav-item">
              <div class="d-flex p-3">
                <button
                  type="submit"
                  class="btn btn--orange btn-back"
                  @click="mainSiteLink()"
                  :style="
                    'background-color:' + MainUISettings.main_site_button_color
                  "
                  :disabled="loading"
                >
                  {{ MainUISettings.main_site_button_text }}
                </button>
              </div>
            </li>
          </ul>
        </div>
        <a
          v-if="isMobile"
          class="navbar-brand mr-auto"
          href="#"
          @click.prevent="$router.push('/booking/home').catch((err) => {})"
        >
          <img
            :src="pubPath + MainUISettings.logo_path"
            v-error-img-load
            v-if="MainUISettings.logo_path"
            class="mh-100"  />
        </a>
        <!-- google translate here -->
        <div class="logged-in-mobile pr-2"></div>
        <button class="navbar-toggler" type="button" @click="navToggle">
          <a
            >Hi {{ details.firstName.replace(/ .*/, "")
            }}<span class="icon icon-person"></span
          ></a>
        </button>

        <!-- DESKTOP VIEW -->
        <div class="navbar-nav flex-row ml-md-auto d-none d-lg-flex">
          <button
            v-if="showBookNow && $route.path == '/booking/queued-bookings'"
            type="submit"
            class="btn btn--white bg-success text-white"
            :disabled="loading"
            @click="bookNow"
          >
            Back to book a service
          </button>
          <button
            v-else-if="showBookNow && is1Coast"
            style="background-color: #57cd3f; color: white"
            type="submit"
            class="btn btn--white"
            :disabled="loading"
            @click="bookNow"
          >
            {{ siteWording || TEXTS.render(`HEADER_BTN_BOOK_NOW`) }}
          </button>
          <button
            v-else-if="showBookNow"
            type="submit"
            class="btn btn--white"
            :disabled="loading"
            @click="bookNow"
          >
            {{ siteWording || TEXTS.render(`HEADER_BTN_BOOK_NOW`) }}
          </button>
          <div class="dropdown">
            <a
              class="btn dropdown-toggle arrow arrow--down"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              ><span class="icon icon-person" tabindex="0"></span>Hi
              {{ details.firstName.replace(/ .*/, "") }}</a
            >
            <div
              class="dropdown-menu border-0 p-0"
              aria-labelledby="dropdownMenuButton"
            >
              <router-link
                v-if="isReducedView == false"
                to="/booking/my-profile"
                class="dropdown-item pt-2 rounded-top text-dark"
                >{{ TEXTS.render(`HEADER_PROFILE`) }}</router-link
              >
              <router-link
                v-if="isReducedView == false"
                to="/booking/faq"
                class="dropdown-item text-dark"
                >{{ TEXTS.render(`HEADER_FAQ`) }}</router-link
              >
              <a
                href="#"
                class="dropdown-item pb-2 rounded-bottom border-bottom-0 logout text-link-blue"
                @click.prevent="$store.dispatch('logout')"
                >{{ TEXTS.render(`HEADER_LOGOUT`) }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!--LOGGED OUT NAV-->
    <nav
      v-else
      class="navbar navbar-expand-lg residentportal-header navbar-collapse navbar-offcanvas"
      :style="'background-color:' + MainUISettings.header_bg_color"
    >
      <div class="container mh-100">
        <a
          class="navbar-brand mh-100"
          href="#"
          @click.prevent="$router.push('/').catch((err) => {})"
        >
          <img 
            :src="pubPath + MainUISettings.logo_path" 
            v-error-img-load
            v-if="MainUISettings.logo_path"
            class="mh-100" 
            :alt="MainUISettings.logo_path_attribute.alt" 
            :title="MainUISettings.logo_path_attribute.title"
          />
        </a>
        <div class="logged-out-mobile ml-auto mr-2"></div>
        <button
          class="navbar-toggler"
          type="button"
          @click="navToggle"
          v-if="
            MainUISettings.breadcrumbs &&
            typeof MainUISettings.breadcrumbs == 'string' &&
            MainUISettings.breadcrumbs.length > 0
          "
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!--Mobile View of Menu-->
        <div class="offcanvas-overlay"></div>
        <div
          class="navbar-collapse offcanvas-collapse"
          :style="
            'background-color:' +
            MainUISettings.header_bg_color +
            ';color:' +
            MainUISettings.button_text_color
          "
        >
          <div
            class="menu-close"
            :style="'background-color:' + MainUISettings.header_bg_color"
          >
            <i @click="navToggle" class="icon icon-close"></i>
          </div>
          <div v-html="MainUISettings.breadcrumbs"></div>
        </div>
        <!--Desktop View of Menu-->
        <div class="collapse navbar-collapse">
          <div v-html="MainUISettings.breadcrumbs"></div>
        </div>
        <!-- google translate here -->
        <div class="logged-out-desktop"></div>
      </div>
    </nav>
    <AlertModal /> 
    <ConfirmationOkModal
      modalId="alertDoubleBooking"
      triggerEventName="alertDoubleBooking" />
  </div>
</template>

<script>

import BookingStateManager from "../utils/BookingStateManager";
import BookingAddressMixin from "../mixins/BookingAddressMixin";
import GoogleTranslateMixin from "../mixins/GoogleTranslateMixin";
import ConfirmationOkModal from "../components/ConfirmationOkModal";
import AlertModal from "../components/AlertModal";
import Texts from "../utils/Texts";
import Helper from "../../helper";
export default {
  props: {
    isReducedView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ConfirmationOkModal, AlertModal
  },
  mixins: [BookingAddressMixin, GoogleTranslateMixin],
  data() {
    return {
      loadingDetails: true,
      details: {
        firstName: "",
      },
      pubPath: process.env.MIX_APP_URL,
      user: false,
      isMobile: null,
    };
  },
  created() {
    this.user = localStorage.AuthToken || false;
  },
  beforeDestroy() {
    $(this.$root.$refs.googleTranslateElement).appendTo('.google-translate-holder');
  },
  methods: {
    deviceWidth() {
      return screen.width <= 992 ? true : false;
    },
    navToggle() {
      $(".offcanvas-collapse").toggleClass("open");
      $(".offcanvas-overlay").toggleClass("open");
      $("body").toggleClass("overflow-hidden");
    },
    logout() {
      this.navToggle();
      this.$store.dispatch("logout");
    },
    mainSiteLink: function() {
      window.open(this.$store.getters.GET_MAIN_UI.main_site_link)
    },
    checkHistoryInUrl() {
      return window.location.href.indexOf("/booking/history") != -1;
    },
    bookNow() {
      this.$store.dispatch('getServerDate');

      var endRoute = "/booking/home"; // Default

      // // Check conditions for from Booking History
      var hasHistoryInUrl = this.checkHistoryInUrl();
      const onBookingPageAlready =
        window.location.href.indexOf("/booking/form") !== -1;

      if (hasHistoryInUrl || onBookingPageAlready) {
        if (hasHistoryInUrl && this.searchAddressToList(this.$store.getters.GET_BOOKING_HISTORY_ADDRESS)) {
          window.eventBus.$emit(
            "alertDoubleBooking",
            this.TEXTS.render(`BOOKING_FORM_MULTIPLE_BOOKING_ERROR_MESSAGE`)
          );

          return false;
        }
        
        if (this.$store.getters.GET_BOOKING_HISTORY_ADDRESS != '') {
          this.addToAddressList(this.$store.getters.GET_BOOKING_HISTORY_ADDRESS);
        }
        var addressOfUrlId = this.addressOfUrlId;
        if (addressOfUrlId) {
          // Create a new booking for the saved address
          var bookingManager = new BookingStateManager();
          var booking = bookingManager.newBooking(addressOfUrlId);
          this.$store.dispatch("resetStepFormIndex");
          endRoute = booking.url.form;

          if (onBookingPageAlready) {
            // Force refresh booking form page!
            // The expected component is BookingFormDetails
            this.$parent.$emit("resetBookingForm");
            this.$parent.$refs.bookingsection.forceMountedData();
            this.$parent.$refs.bookingsection.forceMounted();
            this.$parent.$refs.bookingsection.forceMountedResetCalendar();
            return this.$router.push(endRoute);
          }
        }
      }

      // // --- Reset Fields
      this.$parent.$emit("resetBookingForm");
      return this.$router.push(endRoute);
    },
    bookNowMobile(activeAddress) {
      this.navToggle();
      this.bookNow(activeAddress);
    },
    addCurrentAddressBooking() {
      if (!this.checkHistoryInUrl() && this.$store.getters.GET_BOOKING_HISTORY_ADDRESS != '') {
        this.addToAddressList(this.$store.getters.GET_BOOKING_HISTORY_ADDRESS);
      }
    },
    displayTranslate() {
      if (this.user) {
        if (this.isMobile) {
          $('div#google_translate_element').appendTo('.logged-in-mobile');
        } else {
          $('div#google_translate_element').appendTo('.logged-in-desktop');
        }
      } else {
        if (this.isMobile) {
          $('div#google_translate_element').appendTo('.logged-out-mobile');
        } else {
          $('div#google_translate_element').appendTo('.logged-out-desktop');
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("mainUI");
    this.$store.dispatch('setActiveMultipleServiceBookingSetting');
    setTimeout(() => {
      const info = this.$store.getters["GET_PERSONAL_INFO"];
      this.details.firstName = info.firstName;
      this.$store.dispatch("ribbonNotification");

      this.addCurrentAddressBooking();
    }, 1000);

    // window.addEventListener('focus', () => this.addCurrentAddressBooking());
    document.addEventListener('ready', () => this.addCurrentAddressBooking());

    this.isMobile = this.deviceWidth();
    let vm = this;
    window.onresize = () => {
      vm.isMobile = vm.deviceWidth();
      vm.displayTranslate();
    }
    window.addEventListener('load', () => {
      vm.displayTranslate();
      // Check support browser
      const browserCheck = Helper.detectValidBrowser();
      if(!browserCheck.status) {
        window.eventBus.$emit(
          'alertModal',
          browserCheck.message || vm.TEXTS.render(`BROWSER_NOT_SUPPORTED`)
        )
      }
    })

    this.displayTranslate();
  },
  computed: {
    TEXTS: () => Texts,
    bookingSetting() {
      return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING
    },
    userType() {
      return this.$store.getters.GET_PERSONAL_INFO.type
    },
    loading() {
      return false;
    },
    SubHeader() {
      return this.$route.fullPath;
    },
    RibbonSettings() {
      return this.$store.getters["GET_RIBBON_NOTIFICATION"];
    },
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },
    //Checking whether to show or hide the book now button
    showBookNow() {
      if (this.isReducedView) {
        return false;
      } else if (this.$route.fullPath === "/booking/home") {
        return;
      } else if (this.$route.fullPath.indexOf("/booking/form") > -1) {
        if (this.$store.getters.GET_ACTIVEFORM_INDEX === 3) {
          // We're in completed booking page
          // Allow resident or cso to re-book the same address
          return true;
        }
        return;
      } else {
        return true;
      }
    },
    addressOfUrlId() {
      var address = null;

      var urlQuery = this.$route.query;
      var addressId = urlQuery.id;

      if (addressId != null) {
        var bookingManager = new BookingStateManager();
        address = bookingManager.getAddressFromMapById(addressId);

        if (!address && this.$store.getters.GET_ACTIVEFORM_INDEX === 3) {
          const bookingStateOfAddress = bookingManager.loadBookingStateFromUrl(
            window.location.href
          );
          address =
            (bookingStateOfAddress && bookingStateOfAddress.activeAddress) ||
            undefined;
        }
      }

      return address;
    },
    is1Coast() {
      return Helper.getPortalName() == "1coast";
    },
    siteWording() {
      return this.$store.getters.GET_SITE_WORDINGS.booknow_button_label;
    },
    isShowQueueBookingPage() {
      return this.bookingSetting &&
              this.bookingSetting.enable_queue_booking &&
              this.userType == 'cso' &&
              this.$route.path != '/booking/queued-bookings'
    }
  },
  beforeUnmount() {
    $('div#google_translate_element').appendTo('.google-translate-holder');
  }
};
</script>

<style lang="scss">
.goog-te-gadget {
  color: white;
  .goog-logo-link {
    color: white;
  }
}

#google_translate_element {
  text-align: center !important;
}

@media (max-width: 992px) {
  body {
    top: 0 !important;
  }

  iframe.goog-te-banner-frame {
    display: none !important;
  }
}
</style> 
